function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, String, buckets, tooltipErrorMsg) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("mp-drop-menu", {
        "attrs": __vjadeStringifyAttrsIfObj({
          'open': true,
          'direction': `down`,
        }),
        "on": {
          change: $helpers.menuChange
        },
        "props": {
          positionParent: this
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-bucket-size': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-bucket-size-header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((tooltipErrorMsg) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'always-show': true,
                  'hide-arrow': true,
                  type: `error`,
                }),
              }, [__vjadeSafeCode(tooltipErrorMsg)]));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-bucket-size-title': true
              },
            }, [__vjadeSafeCode($attr(`header`))]));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-bucket-size-selection-row': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-bucket-size-label': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Bracket by");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                "attrs": __vjadeStringifyAttrsIfObj($helpers.getUnitSelectorAttrs()),
                "on": {
                  change: $helpers.handleChangeUnitSelector
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-bucket-size-content-wrapper': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-bucket-size-content': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (buckets);
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, bucket, index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-bucket-size-label': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("" + (`Bracket ` + (index + 1)) + "");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("mp-input", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          type: `number`,
                          'auto-focus': index === 0,
                          'validation-status': $helpers.isBucketValid(index) ? `` : `invalid`,
                          'min': `0`,
                        }),
                        "on": {
                          input: (ev) => $helpers.changeBracketIntervalInput(ev, index),
                        },
                        "hook": {
                          insert: (vnode) => $helpers.insertBucketSizeInput(vnode, index),
                        },
                        "props": {
                          value: bucket.interval
                        },
                        "class": {
                          'mp-bucket-size-input': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-bucket-size-label': true,
                          'mp-bucket-size-label-unit': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("" + (bucket.label) + "");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat((!($helpers.isBucketValid(index))) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'mp-bucket-size-error-message': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("" + (bucket.errorMsg) + "");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var index = $$objKey;
                      if ($$obj.hasOwnProperty(index)) {
                        $$iterated = true;
                        var bucket = $$obj[index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-bucket-size-label': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("" + (`Bracket ` + (index + 1)) + "");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("mp-input", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              type: `number`,
                              'auto-focus': index === 0,
                              'validation-status': $helpers.isBucketValid(index) ? `` : `invalid`,
                              'min': `0`,
                            }),
                            "on": {
                              input: (ev) => $helpers.changeBracketIntervalInput(ev, index),
                            },
                            "hook": {
                              insert: (vnode) => $helpers.insertBucketSizeInput(vnode, index),
                            },
                            "props": {
                              value: bucket.interval
                            },
                            "class": {
                              'mp-bucket-size-input': true
                            },
                          }));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-bucket-size-label': true,
                              'mp-bucket-size-label-unit': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("" + (bucket.label) + "");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat((!($helpers.isBucketValid(index))) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'mp-bucket-size-error-message': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("" + (bucket.errorMsg) + "");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-bucket-size-button-row': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'theme': 'secondary',
              }),
              "on": {
                click: $helpers.cancelBucketSizes
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Cancel");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'theme': 'primary',
                'disabled': tooltipErrorMsg != null || buckets.length === 1
              }),
              "on": {
                click: $helpers.applyBucketSizes
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Apply");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "buckets" in locals ? locals.buckets : typeof buckets !== "undefined" ? buckets : undefined, "tooltipErrorMsg" in locals ? locals.tooltipErrorMsg : typeof tooltipErrorMsg !== "undefined" ? tooltipErrorMsg : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;